module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5266/images/default-avatar.png"